import * as React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { FeaturedHotelPartnersModuleComponent } from './code-split/featured-hotel-partners-module-component';

// Css Style Import
import(/* webpackChunkName: "v1-featured-hotel-partners-module-styles" */ 'src/components/common/modules/v1/featured-hotel-partners-module/styles/featured-hotel-partners-module.css');

const FeaturedHotelPartnersModule: React.FC<ComponentLayoutType<any>> = (props) => {
  return (
    <ComponentLayout {...props}>
      <FeaturedHotelPartnersModuleComponent />
    </ComponentLayout>
  );
};

export default FeaturedHotelPartnersModule;
